var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    style: {
      fill: "#ff6219"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.739 29.342v10.58h11.784c2.105 0 3.814-.396 5.127-1.188 1.313-.792 1.97-2.198 1.97-4.216 0-2.235-.869-3.71-2.605-4.427-1.497-.499-3.407-.749-5.73-.749H35.74Zm0 18.523v12.793h11.784c2.105 0 3.743-.283 4.915-.847 2.127-1.041 3.19-3.038 3.19-5.99 0-2.495-1.03-4.21-3.092-5.143-1.15-.52-2.767-.792-4.85-.813H35.739ZM61.976 26.12c1.476 2.04 2.213 4.481 2.213 7.324 0 2.93-.737 5.284-2.213 7.064-.825.998-2.04 1.91-3.646 2.734 2.452.89 4.302 2.3 5.55 4.232 1.248 1.931 1.872 4.275 1.872 7.031 0 2.843-.716 5.393-2.148 7.65a13.259 13.259 0 0 1-3.419 3.776c-1.54 1.172-3.358 1.975-5.452 2.409-2.094.434-4.367.65-6.82.65H26.17V21.01h23.307c5.881.086 10.048 1.79 12.5 5.11Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB);
export default __webpack_public_path__ + "static/media/b.05bc7ccf73c0a6b60dd6df52e9174293.svg";
export { ForwardRef as ReactComponent };